export default __webpack_public_path__ + "static/media/photo-test3.6b71037b.jpg";